<template>
    <div class="ui-transition-viewport">
        <slot />
    </div>
</template>
<script>
import { onMounted, ref, getCurrentInstance, watch } from 'vue';
import { useResizeObserver } from '../../assets/js/vue/utlis/useResizeObserver';
import { useIntersectionObserver } from '../../assets/js/vue/utlis/useIntersectionObserver';
import Velocity from 'velocity-animate';
import fastdom from 'fastdom';

export default {
    name: 'UiTransitionViewport',
    setup() {
        const slot = ref(null);

        onMounted(() => {
            const isntance = getCurrentInstance();
            slot.value = isntance.slots?.default[0].elm;
        });

        const height = ref(0);

        useResizeObserver(slot, (entries) => {
            let height;
            if (entries?.[0].borderBoxSize !== undefined) { // supported ios >=15.4
                height = entries?.[0].borderBoxSize?.[0]?.blockSize;
            } else {
                fastdom.measure(() => {
                    height = entries?.[0].target.getBoundingClientRect().height;
                });
            }
            fastdom.mutate(() => {
                height.value = height ?? 0;
            });
        });

        const slotIsVisible = ref(false);
        useIntersectionObserver(
            slot,
            ([{ isIntersecting }]) => {
                slotIsVisible.value = isIntersecting;
            },
            {
                rootMargin: '50% 0% 0% -20%'
            }
        );

        watch([slotIsVisible, slot], ([val, el]) => {
            if (!el) return;

            Velocity(el, {
                opacity: val ? 1 : 0,
            }, {
                duration: 700,
                mobileHA: false,
            });

        }, { immediate: true });

        return {
            slot,
            height,
            slotIsVisible,
            // opacity,
        };
    },
};
</script>
<style lang="scss">
.ui-transition-viewport {
    display: contents;
}
</style>
